var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.933334 0.833235C1.4488 0.31777 2.28453 0.31777 2.8 0.833235L7.80215 5.83538C7.91142 5.94465 8.08858 5.94465 8.19785 5.83539L13.2 0.833236C13.7155 0.317771 14.5512 0.31777 15.0667 0.833235V0.833235C15.5821 1.3487 15.5821 2.18444 15.0667 2.6999L9.14286 8.62371C8.51167 9.25489 7.48833 9.25489 6.85714 8.62371L0.933332 2.6999C0.417867 2.18444 0.417868 1.3487 0.933334 0.833235V0.833235Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon_arrow_down.d62acb851ad2bde6b1aa91f1e623228a.svg";
export { ForwardRef as ReactComponent };